import { GET_STORE_DATA, RESET_STATISTICS, REMOVE_ALARM } from '../constants';

export const getStoreData = (store) => ({
    type: GET_STORE_DATA,
    store
});

export const resetStatistics = () => ({
    type: RESET_STATISTICS,
})

export const removeAlarm = () => ({
    type: REMOVE_ALARM,
})
